export interface ClinicWorkingHour {
  day: string;
  open: string;
  close: string;
}

export interface Clinic {
  id: number;
  name: string;
  address?: string;
  city?: string;
  state?: string;
  pincode?: string;
  country?: string;
  contact_number?: string;
  working_hours?: ClinicWorkingHour[];
  slot_duration_minutes?: number;
  status?: 'active' | 'inactive';
}

export interface TimeSlotOption {
  label: string;
  start: string;
  end: string;
  disabled: boolean;
}

export const WEEKDAYS = [
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
  'Sunday',
] as const;

export const SLOT_DURATION_OPTIONS = [
  { label: '15 minutes', value: 15 },
  { label: '30 minutes', value: 30 },
  { label: '45 minutes', value: 45 },
  { label: '1 hour', value: 60 },
  { label: '1.5 hours', value: 90 },
  { label: '2 hours', value: 120 },
];

export function createDefaultWorkingHours(): ClinicWorkingHour[] {
  return WEEKDAYS.map((day) => ({
    day,
    open: day === 'Sunday' ? '' : '09:00',
    close: day === 'Sunday' ? '' : '21:00',
  }));
}
